import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConsultationType } from 'src/pages/types';
import { updateArray } from '../../utils/updateArray';

interface UpdatePayload {
  field: keyof ConsultationType;
  value: any;
  data: Partial<ConsultationType>;
}

export const consultationsSlice = createSlice({
  name: 'consultations',
  initialState: null as Array<ConsultationType> | null,
  reducers: {
    load: (state, action: PayloadAction<Array<ConsultationType>>) => {
      return action.payload;
    },
    addNew: (state, action: { type: string; payload: any }) => {
      return state ? [...state, action.payload] : [action.payload];
    },
    deleteById: (state, action: { type: string; payload: any }) => {
      return state?.filter((el) => el.id !== action.payload);
    },
    updateConsultationBy: (state, action: PayloadAction<UpdatePayload>) => {
      const { field, value, data } = action.payload;
      if (!state) return state;
      return updateArray<ConsultationType>(state, (consultation) => consultation[field] === value, data);
    },
    updateTime: (state, action: PayloadAction<{ id: string; time: number }>) => {
      const session = state?.find((s) => s.id === action.payload.id);

      if (session) {
        session.consultation_time = {
          _seconds: action.payload.time,
          nanoseconds: 0,
        } as any;
      }
      return state;
    },
    resetConsultations: () => {
      return [];
    },
  },
});

export const { load, addNew, deleteById, updateTime, resetConsultations, updateConsultationBy } =
  consultationsSlice.actions;
export default consultationsSlice.reducer;
